import { render } from "./DemoTabComponent.vue?vue&type=template&id=7f2209df"
const script = {}

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Demo/DemoTabComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7f2209df"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7f2209df', __exports__)) {
    console.log('reload')
    api.reload('7f2209df', __exports__)
  }
  
  module.hot.accept("./DemoTabComponent.vue?vue&type=template&id=7f2209df", () => {
    console.log('re-render')
    api.rerender('7f2209df', render)
  })

}


export default __exports__